import * as yup from 'yup'

import { calculateExactAge } from './calculateExactAge'
import { isAgeInScope } from './parseAgeValidation'

export const AGE_VALIDATION_EXCEEDED = 'AGE_VALIDATION_EXCEEDED'

interface ValidationSchemaParams {
  voucherValid: boolean | null
  voucherValue: string | null
  ageValidation?: string | null
}

export function createValidationSchema({
  voucherValid,
  voucherValue,
  ageValidation,
}: ValidationSchemaParams) {
  return {
    anrede: yup.string().required('Dies ist ein Pflichtfeld.'),
    vorname: yup.string().required('Dies ist ein Pflichtfeld.'),
    nachname: yup.string().required('Dies ist ein Pflichtfeld.'),
    strasse: yup.string().required('Dies ist ein Pflichtfeld.'),
    nr: yup.string().required('Dies ist ein Pflichtfeld.'),
    zip: yup
      .string()
      .test(
        'len',
        'Darf nicht länger als 5 Zeichen sein',
        (val) => (val ?? '').length <= 5
      )
      .required('Dies ist ein Pflichtfeld.'),
    ort: yup.string().required('Dies ist ein Pflichtfeld.'),
    bundesland: yup.string().required('Dies ist ein Pflichtfeld.'),
    land: yup.string().required('Dies ist ein Pflichtfeld.'),
    email: yup
      .string()
      .trim()
      .email('Dies ist keine valide E-Mail-Adresse')
      .required('Dies ist ein Pflichtfeld.')
      .test(
        'is-valid-email',
        'Dies ist keine valide E-Mail-Adresse',
        (value) => {
          if (!value) return false
          return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
        }
      ),
    emailConfirm: yup
      .string()
      .trim()
      .email('Dies ist keine valide E-Mail-Adresse')
      .oneOf([yup.ref('email')], 'E-Mail Adressen müssen übereinstimmen.')
      .required('Dies ist ein Pflichtfeld.'),
    telefon: yup.string().required('Dies ist ein Pflichtfeld.'),
    geburtstag: yup
      .string()
      .test('is-date', 'Dies ist ein Pflichtfeld.', (value) => {
        if (!value) return false
        return yup.date().isValidSync(value)
      })
      .test(
        'is-over-18',
        'Du musst mindestens 18 Jahre alt sein.',
        (value) => {
          if (!value) return false
          return calculateExactAge(new Date(value)) >= 18
        }
      )
      .test(
        'age-validation',
        AGE_VALIDATION_EXCEEDED,
        (value) => {
          if (!value || !ageValidation?.trim()) return true
          const exactAge = calculateExactAge(new Date(value))
          return isAgeInScope(exactAge, ageValidation)
        }
      ),
    recievevia: yup.string().required('Dies ist ein Pflichtfeld.'),
    newsletter: yup.boolean(),
    gutschein: yup
      .string()
      .test('is-checked', 'Bitte löse den Gutschein ein.', () => {
        return voucherValid != null || !voucherValue
      })
      .test('is-valid-voucher', '', (value) => {
        if (!value || value.trim() === '') return true
        return voucherValid === true
      }),
    agb: yup
      .boolean()
      .oneOf([true], 'Bitte akzeptiere unsere AGB um fortzufahren.'),
  }
}
